import React from "react";
import { useHistory } from "react-router-dom";
import { GAevent } from "../../utils/Events";
import { EVENT_NAME } from './../../utils/Events';

const AddStripeInvoiceButton = () => {
  const history = useHistory();
  return (
    <div>
      <button
        className="text-white fw-bold  py-2  px-4 bg-theme addWebButton shadow text-nowrap"
        onClick={() => {
          history.push("/advertiser/stripe-invoice/create");
          GAevent(EVENT_NAME.stripe_invoices, [
            "create_invoice",
          ]);
        }}
      >
        CREATE INVOICE
      </button>
    </div>
  );
};

export default AddStripeInvoiceButton;